import Header from "./Header";
import Sponsor from "./Sponsor";
import Services from "./Services";
// import Location from "./Location";
import Products from "./Products";
import Contact from "./Contact";
import Footer from "./Footer";
import Category from "./Category";
import Catalog from "./Catalog";
import About from "./About";
import React, { useState, useEffect } from "react";

const Index = () => {
  const [isVisible, setisVisible] = useState(false);

  const handleScroll = () => {
    if (window.scrollY > 500) {
      setisVisible(true);
    } else {
      setisVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <Header />
      <Services />
      <Category />
      <Contact />
      <Products />
      <Sponsor />
      <Catalog />
      <About />
      <Footer />

      <button
        id="backToTopBtn"
        className="w-10 h-10 bg-slate-800/50 bottom-24 fixed right-8 cursor-pointer flex justify-center items-center hover:bg-slate-900/50 transition  rounded-lg"
        style={{ display: isVisible ? "block" : "none" }}
        onClick={scrollToTop}
      >
        <i
          className="fa fa-chevron-circle-up text-white"
          aria-hidden="true"
        ></i>
      </button>

      <a
        href="https://api.whatsapp.com/send/?phone=6282112965670&text&type=phone_number&app_absent=0"
        className=""
        target="_blank"
      >
        <div className="w-14 h-14 bg-[#25D366] bottom-3 fixed right-6 cursor-pointer flex justify-center items-center rounded-[50%] hover:bg-green-700 transition">
          <i
            className="fa fa-whatsapp text-[30px] text-white "
            aria-hidden="true"
          ></i>
        </div>
        <span className="font-poppins inline-block fixed p-2 text-slate-800 font-light bg-white shadow-md bottom-6 right-[85px] text-[12px] rounded-md">
          Penasaran? <b className="font-bold">Hubungi Kami Sekarang !</b>
        </span>
      </a>
    </>
  );
};

export default Index;
